/**
 * Client-side reader for the variants the edge chose for a visitor without
 * experiment consent. They arrive as a `Server-Timing` metric
 * (`ahead-exp;desc="<urlencoded JSON>"`) on the document response, exposed by
 * the browser on the navigation entry — no cookie, no storage. Cached for the
 * page load; `{}` when absent (e.g. unsupported browser → callers fall through).
 */

const SERVER_TIMING_NAME = "ahead-exp" // keep in sync with lib/pre-consent-variants.ts

let cache: Record<string, string> | undefined

export function readServedVariants(): Record<string, string> {
  if (cache) return cache
  if (typeof performance === "undefined") return {}
  const out: Record<string, string> = {}
  try {
    const nav = performance.getEntriesByType("navigation")[0] as
      | PerformanceNavigationTiming
      | undefined
    const entry = nav?.serverTiming?.find((e) => e.name === SERVER_TIMING_NAME)
    if (entry?.description) {
      const parsed: unknown = JSON.parse(decodeURIComponent(entry.description))
      if (parsed && typeof parsed === "object") {
        for (const [k, v] of Object.entries(parsed)) {
          if (typeof v === "string") out[k] = v
        }
      }
    }
  } catch {
    // malformed / unsupported — treat as none
  }
  // Only cache a hit: the navigation entry is available from the start, but a
  // miss costs one cheap lookup and must not stick if called super early.
  if (Object.keys(out).length) cache = out
  return out
}
